<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card icon="mdi-office-building" title="OTM lar" class="px-5 py-3">
      <v-row>
        <v-btn color="red" class="ml-3" @click="deleteSelected()">o'chirish</v-btn>
        <v-spacer>
          <v-col cols="12" md="4" class="mx-auto" style="margin-top: -8px">
            <v-text-field v-model="search" outlined dense label="Search" append-icon="mdi-magnify" />
          </v-col>
        </v-spacer>
        <v-btn color="primary" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>OTM qo'shish
        </v-btn>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        item-key="name"
        show-select
        :search="search"
      >
        <template v-slot:item.action="{ item }">
          <v-btn-toggle >
            <v-btn small color="cyan" @click="editItem(item)">
              <v-icon small color="white">mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              small
              color="primary"
              @click="$router.push(`/table/faculty/${item.id}`)"
            >Fakultetlar</v-btn>
            <v-btn small color="indigo" @click="$router.push(`/table/subject/${item.id}`)">Fanlar</v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <h1 style="color: #777">{{ indexItem === -1? 'Yangi qo\'shish' : 'O\'zgartirish' }}</h1>
          <v-spacer />
          <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
        </v-card-title>
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" sm="12" lg="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Nomi"
                  :rules="rule"
                  required
                  outlined
                />
              </v-col>
              <v-col cols="12" md="12" sm="12" lg="12">
                <v-text-field
                  v-model="editedItem.phone"
                  :rules="rule"
                  required
                  label="Telefon raqami"
                  outlined
                />
              </v-col>
              <v-col cols="12" md="12" sm="12" lg="12">
                <v-text-field
                  v-model="editedItem.address"
                  :rules="rule"
                  required
                  label="Manzil"
                  outlined
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="text-center container">
            <v-btn text @click="closeModal">Cancel</v-btn>
            <v-spacer />
            <v-btn color="success" :disabled="!valid" @click="saveItem()">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import service from "../../service/University.service";
export default {
  name: "UniversityTable",
  data() {
    return {
      selected: [],
      valid: true,
      rule: [(v) => !!v || "To'ldirilmagan"],
      dialog: false,
      search: "",
      headers: [
        {
          text: "OTM to'liq nomi",
          value: "name",
          width: "25%",
          align: "start",
          divider: true,
        },
        {
          text: "Tell nomer",
          value: "phone",
          width: "20%",
          align: "center",
          divider: true,
        },
        {
          text: "Manzil",
          value: "address",
          width: "35%",
          align: "center",
          divider: true,
        },
        {
          text: "action",
          value: "action",
          width: "20%",
          align: "center",
          divider: true,
        },
      ],
      items: [],
      editedItem: {
        id: "",
        name: "",
        phone: "",
        address: "",
      },
      defaultItem: {
        id: "",
        name: "",
        phone: "",
        address: "",
      },
      indexItem: -1,
      jwt: "",
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      this.jwt = this.$store.getters.jwt;
      service.getAll(this.jwt).then((res) => {
        this.items = res.data;
      });
    },
    editItem(item) {
      this.indexItem = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    saveItem() {
      const item = this.editedItem;
      if (this.indexItem === -1) {
        service.save(item, this.jwt).then((res) => {
          this.items.push(res.data);
        });
      } else {
        service.edit(item, item.id, this.jwt).then((res) => {
          this.items.splice(this.indexItem, 1, res.data);
        });
      }
      this.closeModal();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    deleteSelected() {
      confirm("Are you sure") &&
        this.selected.forEach((item) => {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1);
          service.delete(item.id, this.jwt).then(() => {});
        });
      this.selected = [];
    },
    closeModal() {
      this.indexItem = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = false;
      this.resetValidation();
    },
  },
};
</script>

<style scoped>
</style>
